/**
 * PublicLayout del frontend-superadmin (login, errores).
 *
 * Sprint 11 v2 S11-V2-11. Sin Header. Fondo dark con acento rojo en
 * el wrapper del card del Login.
 */
import { Outlet } from 'react-router-dom';

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-bg-page flex flex-col items-center justify-center p-4">
      <Outlet />
    </div>
  );
}
